var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 46,
    rx: 10,
    fill: "#6D5FF2",
    fillOpacity: 0.14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1898_9393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 21.0002C25.5001 20.2092 26.5531 19.9992 26.8321 20.7402C27.5081 22.5302 28.0001 24.1342 28.0001 25.0002C28.0001 26.3263 27.4733 27.5981 26.5356 28.5357C25.5979 29.4734 24.3262 30.0002 23.0001 30.0002C21.674 30.0002 20.4022 29.4734 19.4646 28.5357C18.5269 27.5981 18.0001 26.3263 18.0001 25.0002C18.0001 24.0702 18.5681 22.2892 19.3221 20.3372C20.2971 17.8092 20.7851 16.5452 21.3881 16.4772C21.5801 16.4552 21.7911 16.4942 21.9631 16.5842C22.5001 16.8642 22.5001 18.2432 22.5001 21.0002C22.5001 21.398 22.6581 21.7796 22.9394 22.0609C23.2207 22.3422 23.6023 22.5002 24.0001 22.5002C24.3979 22.5002 24.7794 22.3422 25.0608 22.0609C25.3421 21.7796 25.5001 21.398 25.5001 21.0002Z",
    stroke: "#6D5FF2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 30.0004L21.7371 29.3434C21.5127 28.784 21.441 28.175 21.5294 27.5788C21.6178 26.9826 21.863 26.4206 22.2401 25.9504C22.3313 25.8364 22.4469 25.7443 22.5785 25.6811C22.71 25.6178 22.8541 25.585 23.0001 25.585C23.1461 25.585 23.2902 25.6178 23.4217 25.6811C23.5533 25.7443 23.6689 25.8364 23.7601 25.9504C24.5261 26.9084 24.7181 28.2044 24.2631 29.3434L24.0001 30.0004",
    stroke: "#6D5FF2",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1898_9393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalories);
export default __webpack_public_path__ + "static/media/Calories.6216f492cb9a48881fe7dc0a0680423e.svg";
export { ForwardRef as ReactComponent };